// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"GroupedActivitiesList_panelContainer__37Lla","panelTitleIcon":"GroupedActivitiesList_panelTitleIcon__1Y9ZN"};